


<template>
  <div
    class="c-spotlight"
    :class="[
      showSummary ? 'c-spotlight--theme-two' : null,
      theme ? `u-color--theme-${theme}` : null,
    ]"
  >
    <a class="c-spotlight-link" :href="link">
      <div
        class="c-spotlight__background-image"
        :style="`background-image: url(${image})`"
      >
        <div class="c-spotlight__content u-color__background">
          <div class="c-spotlight__inner">
            <h2
              v-if="title"
              class="c-spotlight__title u-color__title u-color__title"
            >
              {{ title }}
            </h2>
            <svg class="c-spotlight__icon u-color__icon">
              <use xlink:href="#arrow-right--round" />
            </svg>
          </div>
          <p
            v-if="showSummary"
            class="c-spotlight__summary u-color__summary u-color__summary"
          >
            {{ summary }}
          </p>
          <p class="c-spotlight__date u-color__ribbon">
            <svg class="c-spotlight__date-icon u-color__icon">
              <use xlink:href="#clock" />
            </svg>
            {{ date }}
          </p>
        </div>
      </div>
    </a>
  </div>
</template>
  
<script>
export default {
  name: "Spotlight",
  props: ["date", "image", "link", "showSummary", "summary", "theme", "title"],
};
</script>



// WEBPACK FOOTER //
// src/components/components/wessexwatercorporate/spotlight/Spotlight.vue